export enum ServiceWorkerMessage {
  PRECACHE = "sw.precache",
  SKIP_WAITING = "sw.skip_waiting",
  PREPARE_FOR_API_REFRESH = "sw.prepare_for_api_refresh",
  API_REFRESH_FINISHED = "sw.api_refresh_finished",
  UPDATE_STATE = "sw.update_state",
}

export enum ServiceWorkerResponse {
  PRECACHE_FINISH = "sw.precache_finish",
  READY_FOR_API_REFRESH = "sw.ready_for_api_refresh",
}
